import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LabelService } from '../../../services/label.service';

@Component({
  selector: 'app-simplified-header',
  standalone: true,
  imports: [],
  templateUrl: './simplified-header.component.html',
  styleUrl: './simplified-header.component.scss',
})
export class SimplifiedHeaderComponent {
  constructor(
    private router: Router,
    private labelService: LabelService
  ) {}

  navigateToHomePage() {
    this.router.navigate(['/homepage']);
  }
}
